import { jsx as _jsx } from "react/jsx-runtime";
import { freddyTheme, IconButton, Link, useMediaQuery } from '@coolblue-development/freddy';
import { InfoCircled } from '@coolblue-development/icons';
import { Device } from '@coolblue-development/next-request-context';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { useTranslation } from '../../i18n/useTranslation.js';
import useTestId from '../utils/useTestId.js';
export function ExplanationIcon({ onClick, testId, ml = 100 }) {
    const { device } = useRequestContext();
    const { t } = useTranslation('explanationIcon');
    const testIdProps = useTestId(testId);
    const isMobile = useMediaQuery(freddyTheme.breakpoint.maxWidth('md'), device === Device.MOBILE);
    return isMobile ? (_jsx(Link, { ...testIdProps, onClick: onClick, ml: ml, component: "button", children: `${t('label')}` })) : (_jsx(IconButton, { size: "xsmall", ml: ml, "aria-label": t('label'), onClick: onClick, ...testIdProps, children: _jsx(InfoCircled, { color: "base", innerFill: "contrast" }) }));
}
export default ExplanationIcon;
//# sourceMappingURL=ExplanationIcon.js.map